import React from "react";

//Third Party
import { useTable, useSortBy, useFilters, Column } from "react-table";
import { useExportData } from "react-table-plugins";
import "jspdf-autotable";
//Styles

import { useLocation, useNavigate } from "react-router-dom";
import {
  ButtonWithoutIcon,
  CustomPagination,
  SquireIconWrapper,
} from "../../lib";
import { KTIcon } from "../../../../../_metronic/helpers";

// Define the Attendee interface
export interface Attendee {
  id: number;
  firstName: string | null;
  lastName: string | null;
  name: string;
  mobile: string;
  national_code: string;
  male: boolean;
  nationalCodeVerifiedAt: string | null;
  ticket: any[]; 
}

export interface AttendeesListTableProps {
  data: {
    attendees: Attendee[];
    totalRows: number;
  };

  queryString: any; 
  setQueryString: (query: any) => void; 
  refetch: () => void;
  numberInPage: number;
  matchId: number;
}

const FanReportTableMatch = ({
  data,
  queryString,
  setQueryString,
  refetch,
  numberInPage,
  matchId,
}: AttendeesListTableProps) => {
  let userId: any = "";
  const location = useLocation();
  const state = location.state as any;
  console.log("Location state:", state);
  const navigate = useNavigate();
  // Define a default UI for filtering
  function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
  }) {
    const count = preFilteredRows.length;

    return (
      <input
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records...`}
      />
    );
  }

  const defaultColumn = {
    Filter: DefaultColumnFilter,
  };

  const columns = React.useMemo<Column<Attendee>[]>(
    () => [
      {
        Header: <HeaderTextIcon text={"ردیف"} />,
        accessor: "id",
        Cell: ({ row }) => (
          <span className="rowNum">
            {(queryString.page - 1) * Number(numberInPage) + row.index + 1}
          </span>
        ),
      },
      {
        Header: <HeaderTextIcon text={"نام و نام خانوادگی هوادار"} />,
        accessor: "name",
      },
      {
        Header: <HeaderTextIcon text={"شماره موبایل هوادار"} />,
        accessor: "mobile",
      },
      {
        Header: <HeaderTextIcon text={"کد ملی هوادار"} />,
        accessor: "national_code",
      },
      {
        Header: <HeaderTextIcon text={"جنسیت"} />,
        accessor: "male",
        Cell: ({ value }) => <span>{value ? "مرد" : "زن"}</span>,
      },
    ],
    [queryString.page, numberInPage]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable<Attendee>(
    {
      columns,
      data: data.attendees || [],
    },
    useSortBy
  );

  return (
    <div className={"p-c-30"}>
      <div style={{ overflow: "auto" }}>
        <table
          {...getTableProps()}
          className="table align-middle table-row-dashed fs-6 gy-5"
        >
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end mt-5">
        <CustomPagination
          activePage={queryString.page}
          setQueryString={setQueryString}
          totalRows={data?.totalRows}
          numberInPage={numberInPage}
        />
      </div>
    </div>
  );
};

const HeaderTextIcon = ({ text }: { text: string }) => (
  <div
    className={"d-flex align-items-center justify-content-center gap-2"}
    style={{ whiteSpace: "nowrap", margin: "0 5px" }}
  >
    <span>{text}</span> <KTIcon iconName={"filter"} className={"fs-5"} />
  </div>
);

const IconsCell = ({ league, refetch, page }: any) => {
  const icons = [
    {
      iconClass: "fc-12 color-yellow-c",
      iconName: "pencil",
      wrapperClass: "bg-light-yellow-c",
    },
    {
      iconClass: "fc-12 color-red-c",
      iconName: "trash",
      wrapperClass: "bg-light-red-c",
    },
  ];
  const navigate = useNavigate();
  const [delItem, setDelItem] = React.useState<any>(null);
  const [showDelModal, setShowDelModal] = React.useState<boolean>(false);
  const handleActionClick = (icon: any, team: any) => {
    if (icon.iconName === "pencil") {
      navigate(`/leagues/edit-league?page=${page}`, { state: team });
    } else {
      setDelItem(() => {
        return {
          id: league.id,
        };
      });
      setShowDelModal(true);
    }
  };
  return (
    <>
      <div className={"IconCell"}>
        {icons.map((icon) => (
          <a onClick={(e) => handleActionClick(icon, league)}>
            <SquireIconWrapper {...icon} />
          </a>
        ))}
      </div>
    </>
  );
};

export default FanReportTableMatch;
